export const hkConfig = {
  taxOfficeName: 'IRD',
  deliveryTaxOfficeQuestionTag: 'IRD',
  searchPlaceholder: "Search taxpayers using names, Atlas ID or GTS ID...",
  taxId: "File Number",
};
